// removed by extract-text-webpack-plugin
module.exports = {"SliderPointerDragFix":"HistoryPanel-SliderPointerDragFix","HistorySlider":"HistoryPanel-HistorySlider","DarkNavLink":"HistoryPanel-DarkNavLink"};


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/theme/History/components/HistoryPanel.less
// module id = 115
// module chunks = 0